<template>
  <div class="about">
    <div class="top-img">
      <img style="width: 100%;" src="@/assets/images/k2hqdmpfendk2hqdmpfend.jpg"
           alt="YwgA84rAI">
    </div>
    <Introduce/>
    <BossMessage/>
    <Cultural/>
    <Business/>
    <Contact/>
  </div>
</template>

<script>
import Introduce from './Introduce'
import Cultural from './Cultural'
import BossMessage from './BossMessage'
import Business from './Business'
import Contact from './Contact'

export default {
  name: "About",
  components: {Introduce, Business, Cultural, BossMessage, Contact},
  mounted() {
    this.goAnchorModel(this)
  }
}
</script>

<style scoped lang="less">
.about {

}
</style>